module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-62771ff72cfd5b83695a5134f47a0a20.png";